module.exports = __webpack_public_path__ + "img/bg_main_t_l_2.4d03c16a.png";